export default function promiseMiddleware() {
  return next => action => {
    const { promise, type, ...rest } = action;

    if (!promise) {
      return next(action);
    }

    const SUCCESS = type;

    const REQUEST = '_REQUEST';
    const FAILURE = '_FAILURE';
    const REQUEST_TYPE = `${type}_REQUEST`;
    const FAILURE_TYPE = `${type}_FAILURE`;

    next({ ...rest, type: REQUEST });
    next({ ...rest, type: REQUEST_TYPE });

    return promise
      .then(res => {
        next({ ...rest, res, type: SUCCESS });
        next({ ...rest, res, type: '_SUCCESS' });

        return res;
      })
      .catch(error => {
        const response = error.response;
        const redirectUrl = response?.data?.redirect_url; // TODO for onboarding

        next({ ...rest, error, type: FAILURE });
        next({ ...rest, error, type: FAILURE_TYPE });

        if (response?.status === 401 && redirectUrl) {
          window.location = redirectUrl;
        }

        return promise;
      });
  };
}
